import { NextUrlRedirectService } from "./next-url-redirect.service";

export const nextUrlRedirectService = new NextUrlRedirectService();
